import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import apiService from '../services/api';
import SaveEffectsPanel, { SaveEffect } from './pp/SaveEffectsPanel';

// Derives the "Ao salvar" list from the primary procedure's links (/api/procedures/:id/links) and the modal's own send flags.
const AppointmentSaveEffects: React.FC<{ procedureId?: number; procedureName?: string; patientId?: number; validityDays?: number | null; sendConsent: boolean; sendIntake: boolean }> = ({ procedureId, procedureName, patientId, validityDays, sendConsent, sendIntake }) => {
  const { t } = useTranslation();
  const [links, setLinks] = useState<any>(null);
  useEffect(() => {
    setLinks(null);
    if (!procedureId) return;
    let cancelled = false;
    Promise.resolve().then(() => apiService.get(`/api/procedures/${procedureId}/links`)).then((r: any) => { if (!cancelled && r.success) setLinks(r.data); }).catch(() => {});
    return () => { cancelled = true; };
  }, [procedureId]);
  // the patient's active package for this procedure (debited on completion)
  const [pkg, setPkg] = useState<{ name: string; used: number; total: number } | null>(null);
  useEffect(() => {
    setPkg(null);
    if (!patientId || !procedureName) return;
    let cancelled = false;
    Promise.resolve().then(() => apiService.get(`/api/packages/balances?patientId=${patientId}&status=active`)).then((r: any) => {
      const b = r.success && (r.data || []).find((x: any) => x.procedure_name === procedureName && x.sessions_remaining > 0);
      if (!cancelled && b) setPkg({ name: b.package_name, used: b.sessions_used, total: b.sessions_total });
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [patientId, procedureName]);
  if (!procedureId || !links) return null;

  const effects: SaveEffect[] = [];
  if (pkg) effects.push({ ok: true, text: t('saveEffects.package', { name: pkg.name, n: pkg.used + 1, total: pkg.total }) });
  const docs = [...links.consents.map((c: any) => c.name), ...links.intakes.map((i: any) => i.name)];
  if (docs.length) effects.push({ ok: sendConsent || sendIntake, text: t('saveEffects.docs', { docs: docs.join(', ') }) });
  if (links.items.length) effects.push({ ok: true, text: t('saveEffects.items', { items: links.items.map((i: any) => `${Number(i.quantity)} ${i.unit} ${i.name}`).join(', ') }) });
  if (validityDays) effects.push({ ok: false, text: t('saveEffects.recall', { days: validityDays }) });
  if (!effects.length) return null;
  return <SaveEffectsPanel title={t('saveEffects.title')} effects={effects} />;
};

export default AppointmentSaveEffects;
